interface PassportSummaryLineProps {
  countryCount: number;
  destinationCount: number;
  className?: string;
}

/**
 * The Passport's headline, not a stat card: a large serif number reads as part of
 * the surfer's own travel identity, with destination count folded in quietly as
 * supporting metadata on the same label line rather than a separate figure.
 * Deliberately renders at 0 too -- an empty Passport should still look composed,
 * not like a stat that hasn't loaded yet.
 */
const PassportSummaryLine = ({ countryCount, destinationCount, className }: PassportSummaryLineProps) => (
  <div className={className}>
    <span className="block font-serif text-6xl md:text-7xl text-primary tabular-nums leading-none">
      {countryCount}
    </span>
    <p className="mt-2 text-xs uppercase tracking-wide text-foreground">
      {countryCount === 1 ? 'Country surfed' : 'Countries surfed'}
      <span className="text-muted-foreground">
        {' '}
        · {destinationCount} {destinationCount === 1 ? 'destination' : 'destinations'}
      </span>
    </p>
  </div>
);

export default PassportSummaryLine;
